import { Row, Col } from "antd";
import Subtitle from "../../Subtitle";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";
import { Milestone, DollarSign, Landmark, User } from "lucide-react";

export default function ArancelesSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <>
      <Subtitle title="Aranceles" marginTop={16} />
      <Row style={{ marginTop: 5 }}>
        <Col {...responsiveInfo}>
          <DataGroup
            title={"Aranceles"}
            formName="Aranceles"
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Milestone size={16} />}
              iconColor="#1890ff"
              keyName="Distancia Arancel"
              value={verification?.DistanciaArancel}
              valueType="number"
              suffix="KM"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<DollarSign size={16} />}
              iconColor="#82cc4b"
              keyName="Monto"
              value={verification?.Monto}
              valueType="currency"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Landmark size={16} />}
              iconColor="#ffc53d"
              keyName="Comisión Unidad"
              value={verification?.ComisionUnidad}
              valueType="currency"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<User size={16} />}
              iconColor="purple"
              keyName="Comisión Verificador"
              value={verification?.ComisionVerificador}
              valueType="currency"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
      </Row>
    </>
  );
}